<template>
  <div>
    <form-dialog :title="title" :dialogVisible="mtCheckVisible" dWidth="900px" :dtop="dtop" :isAppend="isAppend"
      @closeDialog="mtCheckClose">
      <div class="diamain">
        <div class="header">
          <div class="button-groups">
            <div class="button" @click="changeType('counters')"
              :class="{ isButtonActive: this.current_type == 'counters' }">
              {{ $t('aci4') }}</div>
            <div class="button" @click="changeType('terminal')"
              :class="{ isButtonActive: this.current_type == 'terminal' }">
              {{ $t('schedule.terminalList') }}</div>
          </div>
        </div>
        <div class="diaimg">
          <template v-if="current_type == 'counters'">
            <el-table :data="schedule_table_list" height="100%">
              <!-- <el-table-column type="index" :label="$t('terminal.no')" width="150">
              </el-table-column> -->
              <el-table-column prop="action" :label="$t('terminal.types')">
                <template slot-scope="scope">
                  <template v-if="scope.row.action == 2">
                    {{ $t('terminal.conBright') }}
                  </template>
                  <template v-if="scope.row.action == 3">
                    {{ $t('terminal.action3') }}
                  </template>
                  <template v-if="scope.row.action == 4">
                    {{ $t('terminal.action4') }}
                  </template>
                  <template v-if="scope.row.action == 5">
                    {{ $t('terminal.action5') }}
                  </template>
                  <template v-if="scope.row.action == 6">
                    {{ $t('terminal.action6') }}
                  </template>
                  <template v-if="scope.row.action == 7">
                    {{ $t('terminal.action7') }}
                  </template>
                  <template v-if="scope.row.action == 8">
                    {{ $t('terminal.action8') }}
                  </template>
                </template>
              </el-table-column>
              <el-table-column prop="value" :label="$t('terminal.value')">
                <template slot-scope="scope">
                  <template v-if="scope.row.action == 6">
                    <template v-if="scope.row.value == 1">
                      {{ $t('terminal.acVa1') }}
                    </template>
                    <template v-if="scope.row.value == 2">
                      {{ $t('terminal.acVa2') }}
                    </template>
                    <template v-if="scope.row.value == 3">
                      {{ $t('terminal.acVa3') }}
                    </template>
                  </template>
                  <template v-else-if="scope.row.action == 7 || scope.row.action == 8">
                    {{ `${scope.row.pcList.length == 0 ? '无' : scope.row.pcList}` }}
                  </template>
                  <template v-else>
                    {{ scope.row.value }}
                  </template>
                </template>
              </el-table-column>
              <el-table-column prop="isDateLimit" :label="$t('terminal.isDateLimit')" width="180">
                <template slot-scope="scope">
                  <template v-if="scope.row.isDateLimit === true">
                    {{ `${scope.row.dateStart}-${scope.row.dateEnd}` }}
                  </template>
                  <template v-else>
                    {{ $t('terminal.noLimit') }}
                  </template>
                </template>
              </el-table-column>
              <el-table-column :label="$t('terminal.isWeekLimit')">
                <template slot-scope="scope">
                  <template v-if="scope.row.isWeekLimit">
                    <template v-if="scope.row.validWeek != 0">
                      {{ scope.row.weeks }}
                    </template>
                    <template v-else>
                      {{ $t('terminal.noLimit') }}
                    </template>
                  </template>
                  <template v-else>
                    {{ $t('terminal.noLimit') }}
                  </template>
                </template>
              </el-table-column>
              <el-table-column prop="startTime" :label="$t('terminal.excTime')">
              </el-table-column>
            </el-table>
          </template>
          <template v-if="current_type == 'terminal'">
            <el-table :data="device_table_list" height="100%" v-loading="deviceListLoading" :key="Math.random()">
              <el-table-column prop="name" :label="$t('terminal.deviceName')" width="180px">
              </el-table-column>
              <el-table-column prop="remark1" :label="$t('terminal.remark')">
                <template slot-scope="scope">
                  <template v-if="scope.row.remark1 == ''">
                    -
                  </template>
                  <template v-else>
                    {{ scope.row.remark1 }}
                  </template>
                </template>
              </el-table-column>
              <el-table-column prop="group_name" :label="$t('review.group')">
              </el-table-column>
              <el-table-column prop="size_remark" :label="$t('schedule.resolution')"></el-table-column>
              <el-table-column :label="$t('terminal.status')">
                <template slot-scope="scope">
                  <span :style="'color:' + scope.row.runStateInfo.stateColor">{{ $t(scope.row.runStateInfo.stateName)
                  }}</span>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </div>
        <div class="diainput">
          <template v-if="this.current_detail != null">
            <template v-if="this.current_detail.publish_state == 0 && isReview">
              <div class="content">
                <el-input v-model="reject_data" size="small" :placeholder="$t('review.resonForReject')"></el-input>
              </div>
              <div class="button">
                <el-button type="success" size="small" style="margin-left: 6px;" @click="publish()" round>{{
                  $t('review.approve') }}</el-button>
                <el-button type="danger" size="small" @click="reject()" round>{{ $t('review.rejectReview')
                }}</el-button>
                <!-- <div class="publishs" @click="publish()">通过</div>
							<div class="reject" @click="reject()">拒绝</div> -->
              </div>
            </template>
            <template v-if="this.current_detail.publish_state == 2">
              <div style="width: 100%;text-align: center;color: green;font-size: 20px;">{{ $t('review.pass') }}</div>
            </template>
            <template v-if="this.current_detail.publish_state == 1">
              <div
                style="width: 100%;text-align: center;font-size: 20px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                <span style="color: red">{{ $t('review.reject') }}</span>
                <span>:</span>
                <el-popover placement="top-start" trigger="hover" width="200"
                  :content="this.current_detail.check_remark">
                  <span slot="reference" style="margin-left: 10px;">
                    {{ this.current_detail.check_remark }}</span>
                </el-popover>
              </div>
            </template>
          </template>
        </div>
      </div>
    </form-dialog>
  </div>
</template>

<script>
import FormDialog from '@/components/basics/FormDialogConfirm';
import {
  mPagination
} from "@/components/basics/mixins";
import {
  runStateInfo
} from "@/assets/scripts/runState";
import {
  changeDeviceStateName
} from "@/assets/scripts/changeDeviceStateName";
import {
  daysWeek,
  powerAndCard
} from "@/assets/scripts/publicFunction.js";

export default {
  name: "PublishCheck",
  mixins: [mPagination],
  components: {
    FormDialog
  },
  props: {
    current_detail: {
      type: Object,
      default: null
    },
    isVisible: {
      type: Boolean,
      default: false
    },
    deviceList: {
      type: Array
    },
    scheduleList: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: "发布审核"
    },
    isAppend: {
      type: Boolean,
      default: false
    },
    dtop: {
      type: String,
      default: '0'
    },
    isReview: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      mtCheckVisible: false,
      deviceListLoading: false,
      current_type: 'play',
      device_table_list: [],
      schedule: [],
      reject_data: '',
      lookp: false,
      initLook: true,
      lookpIndex: 0,
      vdrList: [],
      screenParam: {
        type: 'look', //add/look/edit/copy
        name: '',
        groupId: '',
        resolution: '',
        id: '',
        w: '',
        h: ''
      }
    }
  },
  methods: {
    async lookProgram(row, index) {
      this.lookpIndex = index;
      let wh = row.size_remark.split("x");
      this.screenParam.name = row.name;
      this.screenParam.groupId = row.group_id;
      this.screenParam.resolution = row.size_remark;
      this.screenParam.id = row.id;
      this.screenParam.w = wh[0];
      this.screenParam.h = wh[1];
      await this.$http.post("/admin/play/detail", { play_id: this.screenParam.id }, data => {
        this.vdrList = data.object_json;
      });
      this.lookp = true;

      this.initLook = false;
      setTimeout(() => { this.initLook = true; }, 10);
    },
    closeLookp() {
      this.lookp = false;
    },
    mtCheckClose() {
      this.mtCheckVisible = false;
      this.$emit('closeCheck');
    },
    changeType(type) {
      this.current_type = type;
      if (this.current_type == 'terminal') {
        let device_ids = [];
        // console.log(this.deviceList);
        this.deviceList.forEach((ele) => {
          device_ids.push(ele.id)
        });
        this.deviceListLoading = true;
        this.$http.post('/admin/device/list', {
          group_ids: sessionStorage.getItem('group_ids'),
          limit: 1000,
          page: 1,
          device_ids: device_ids.toString()
        }, data => {
          this.device_table_list = data.list ? data.list : [];
          this.device_table_list.forEach((ele) => {
            ele.runStateInfo = runStateInfo(ele.run_state, ele.group_run_status);
            ele.runStateInfo = changeDeviceStateName(ele.runStateInfo);
          })
          this.deviceListLoading = false;
        });
      }
    },
    async publish() {
      await this.$http.post("/admin/check/checkCountersPublish", {
        check_result: 2,
        remark: this.reject_data,
        publish_ids: this.current_detail.id
      }, () => {
        // this.$bus.$emit('publish-event', "open-download");
      });
      this.$emit('updateData');
      this.mtCheckVisible = false;
    },
    async reject() {
      if (!this.reject_data) {
        this.$msg({
          type: 'warning',
          message: this.$t('review.resonForReject')
        })
      } else {
        await this.$http.post("/admin/check/checkCountersPublish", {
          check_result: 1,
          remark: this.reject_data,
          publish_ids: this.current_detail.id
        })
        this.$emit('updateData');
        console.log('原因', this.reject_data);
        this.mtCheckVisible = false;
      }
    },
  },
  computed: {
    schedule_table_list() {
      return (this.scheduleList || []).map(ele => {
        let item = { ...ele };
        item.weeks = daysWeek(item.validWeek);
        if (item.action == 7 || item.action == 8) {
          item.pcList = powerAndCard(item.value);
        }
        return item;
      });
    }
  },
  watch: {
    isVisible() {
      this.current_type = 'counters';
      this.mtCheckVisible = this.isVisible;
    }
  }
}
</script>

<style lang="scss" scoped>
.diamain {
  width: 96%;
  height: 500px;
  margin: 5px auto;
  display: flex;
  flex-direction: column;
  align-items: center;

  .header {
    width: 100%;
    height: 40px;
    border-bottom: 1px solid #d7ecf3;

    .button-groups {
      width: 420px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .button {
        text-align: center;
        width: 130px;
        height: 30px;
        line-height: 30px;
        border-style: solid;
        border-width: 1px;
        cursor: pointer;
        border-image-slice: 1;
        border-radius: 17px;
        color: var(--theme-color-customized-1);
      }

      .isButtonActive {
        // background-image: linear-gradient(270deg,
        //     #86eae7 0%,
        //     #4cccf0 45%,
        //     #11adf8 100%),
        //   linear-gradient(#cfd5d8, #cfd5d8);
        // background-blend-mode: normal, normal;
        background-color: var(--theme-color-customized-1);
        color: #ffffff;
      }
    }

    .button-groups>.button:hover {
      background-color: rgba(216, 255, 253, 0.7);
    }
  }

  .diaimg {
    width: 830px;
    height: 400px;
    overflow-y: auto;

    .tab {
      width: 100%;
      height: calc(100% - 40px);
      overflow-y: scroll;

      background-color: pink;
    }

    /deep/ .el-tabs__content {
      flex-grow: 1;
      overflow-y: auto;
    }
  }

  .diainput {
    height: 60px;
    width: 100%;

    display: flex;
    align-items: center;

    .content {
      flex: 1;
    }

    // .button {
    // 	width: 30%;
    // 	padding-left: 20px;
    // 	display: flex;
    // 	align-items: center;
    // 	justify-content: space-between;
    // 	.publishs {
    // 		width: 80px;
    // 		height: 35px;
    // 		cursor: pointer;
    // 		border-style: solid;
    // 		border-width: 1px;
    // 		border-image-slice: 1;
    // 		border-color: linear-gradient(270deg,
    // 				#86eae7 0%,
    // 				#4cccf0 45%,
    // 				#11adf8 100%);
    // 		border-radius: 20px;
    // 		color: var(--theme-color-customized-1);
    // 		line-height: 35px;
    // 		text-align: center;
    // 	}

    // 	.reject {
    // 		width: 80px;
    // 		height: 35px;
    // 		cursor: pointer;
    // 		border-style: solid;
    // 		border-width: 1px;
    // 		border-image-slice: 1;
    // 		border-color: linear-gradient(270deg,
    // 				#ff907e 0%,
    // 				#ff7878 45%,
    // 				#ff5f72 100%);
    // 		border-radius: 20px;
    // 		color: #ff4949;
    // 		line-height: 35px;
    // 		text-align: center;
    // 	}
    // }
  }
}

/deep/ .look-p {
  .el-dialog__body {
    padding-top: 0px !important;
    padding-bottom: 16px !important;
  }
}

@media screen and (min-width: 1200px) {
  ::-webkit-scrollbar {
    width: 4px;
    height: 4px;
    background-color: rgba(240, 240, 240, 1);
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 2px;
    box-shadow: inset 0 0 0px rgba(53, 202, 250, 0.3);
    background-color: rgba(53, 202, 250, 0.3);
  }
}
</style>
